require('./monthlyChart.scss');

//@vendors
import React from 'react';
import PropTypes from 'prop-types';

class MonthlyChart extends React.Component {

    getStickAngle = () => {
        const { monthlyValue } = this.props;
        if(monthlyValue === 0) return -90;
        const valueDegBar =  - (-180 * monthlyValue) - (monthlyValue < 0 ? 0 : 180)
        return valueDegBar
    }

    render() {
        const { monthlyValue } = this.props;

        return (
            <div className="monthly-chart">
                <div className="monthly-chart__sector">{}</div>
                <div className="monthly-chart__sector">{}</div>
                <div className="monthly-chart__sector">{}</div>
                <div className="monthly-chart__stick-container">
                    <div className="monthly-chart__stick-container__circle">{}</div>
                    <div
                        className="monthly-chart__stick-container__stick"
                        style={
                            {
                                transform: `rotate(${monthlyValue !== null ? this.getStickAngle() : 0}deg)`
                            }
                        }
                    >{}</div>
                </div>
            </div>
        );
    }
}

MonthlyChart.propTypes = {
    monthlyValue: PropTypes.number,
};

module.exports = MonthlyChart;
